var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import get from 'lodash/get';
import { Labeled, useRecordContext, } from 'react-admin';
import { styled } from '@mui/material';
import { Viewer } from './toast-ui';
import { toastuiEditorStyles } from './toastuiEditorStyles';
/**
 * An Field component for markdown content
 *
 * @example
 *
 *    import { Show, SimpleLayout, TextField } from 'react-admin';
 *    import { MarkdownField } from '@react-admin/ra-markdown';
 *
 *    const PostShow = () => (
 *        <Show>
 *            <SimpleLayout>
 *                <TextField source="title" />
 *                <MarkdownField source="description" />
 *            </SimpleLayout>
 *        </Show>
 *    );
 *
 * Based on the '@toast-ui/react-editor' package.
 */
export var MarkdownField = function (props) {
    var className = props.className, source = props.source, sx = props.sx, rest = __rest(props, ["className", "source", "sx"]);
    var record = useRecordContext(props);
    var value = get(record, source);
    return (React.createElement(Root, { className: className, sx: sx },
        React.createElement(Viewer, __assign({ initialValue: value }, rest))));
};
var Root = styled(Labeled, {
    name: 'RaMarkdownField',
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var theme = _a.theme;
    return "\n    ".concat(toastuiEditorStyles, "\n    .toastui-editor-contents p, .toastui-editor-contents ul, .toastui-editor-contents menu, .toastui-editor-contents ol, .toastui-editor-contents dir {    \n        color: ").concat(theme.palette.text.primary, ";\n    }\n    .toastui-editor-contents pre {\n        background-color: ").concat(theme.palette.background.default, ";\n        color: ").concat(theme.palette.text.primary, ";\n    }\n    toastui-editor-contents a {\n        color: ").concat(theme.palette.mode === 'light'
        ? theme.palette.primary.dark
        : theme.palette.primary.light, ";\n    }\n");
});
